import { appendParams } from '@utils/func'
import { API } from '@utils/axios'
import { IAPI } from 'AppTypes'

class BannerNotificationManagementAPI implements IAPI {
  prefix = '/BannerNotificationManagement'

  fetchList (params: TBannerNotificationManagementAPI.Params.FetchList) {
    const url = appendParams(`${this.prefix}/List`, { ...params })
    return API.get<TBannerNotificationManagement.TState['notificationList']>(url)
  }

  fetchSingle (id: string) {
    return API.get<TBannerNotificationManagement.TState['notificationUpsert']>(`${this.prefix}/GetDetail/${id}`)
  }

  async create (data: any) {
    const response = await API.post<TBannerNotificationManagement.TState['notificationUpsert']>(`${this.prefix}/Create`, data)
    return response.data
  }

  async update (data: any) {
    const response = await API.put<TBannerNotificationManagement.TState['notificationUpsert']>(`${this.prefix}/Update`, data)
    return response.data
  }
}

export const bannerNotificationManagementAPI = new BannerNotificationManagementAPI()
